export default {
  changetitle(state, title) {
    state.title = title
  }
}



// WEBPACK FOOTER //
// ./src/Vuex/mutations.js